export { default } from './availability-pickup-text';
